var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgT = function SvgT(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.83 7.916c-.2-1.662.763-2.002 4.166-2.083m0 0c3.437.084 4.452.499 4.167 2.083M9.996 5.833v8.333m-1.666 0h3.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.245 3.242c-1.16 1.16-1.16 3.026-1.16 6.758s0 5.598 1.16 6.757c1.16 1.16 3.026 1.16 6.758 1.16s5.598 0 6.757-1.16c1.16-1.16 1.16-3.025 1.16-6.757s0-5.598-1.16-6.758c-1.16-1.159-3.026-1.159-6.757-1.159-3.732 0-5.598 0-6.758 1.16"
  })));
};
export default SvgT;